import { RenderFileType } from './types';

export const renderApiProfileUiPath = '/render-api-profile';
export const renderViewUiPath = '/render/chart';
export const defaultRenderFileType = RenderFileType.PNG;

/**
 * Whether a pathname is one of the dedicated render views that upshot's
 * headless browser loads for PDF/PNG exports. UI chrome (floating buttons,
 * devtools toggles, …) must not mount on these paths or it gets printed
 * into customer-facing exports.
 */
export function isRenderViewPathname(pathname: string): boolean {
  return [renderViewUiPath, renderApiProfileUiPath].some(path => pathname === path || pathname.startsWith(`${path}/`));
}

export const rendererMinWidth = 700;
export const rendererMaxWidth = 1400;
export const rendererDefaultWidth = 900;

// TODO OA: Figure out how to handle this a bit more dynamically.
export const shareImageRenderWidth = 1440; // Optimized for page layout and aspect ratio
export const shareImageRenderHeight = 754; // // 628 * 1440 / 1200
export const shareImageFullWidth = 1200;
export const shareImageFullHeight = 628;
export const shareImageHorizontalMargin = 50;
export const rendererShareImageWidth = shareImageFullWidth - shareImageHorizontalMargin * 2;
export const renderViewDefaultHorizontalMargin = 50;
export const renderViewDefaultTopMargin = 36;

// Note: the PNG size should stay relatively stable for API customers who have integrating the profile image
export const pngScaleFactor = 3;
export const pngLeftPadding = 10;

const textScaleMultiplier = 0.8;
export const middlePartWidth = 120 * textScaleMultiplier;
